module.exports = __webpack_public_path__ + "media/honey-icons/icon-play-948dd608.svg";